import React from 'react';
import { SearchIcon, MapPinIcon } from 'lucide-react';
interface SearchBarProps {
  locationSearch: string;
  setLocationSearch: (search: string) => void;
  placeholder?: string;
}
const SearchBar: React.FC<SearchBarProps> = ({
  locationSearch,
  setLocationSearch,
  placeholder = 'Search by city, state, or zip code...'
}) => {
  return <div className="relative max-w-md mx-auto mb-8" data-id="element-1564" data-mp="2th8z1wputaym">
      <div className="relative" data-id="element-1565" data-mp="2fqx13h6l8hzk">
        <MapPinIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-gray-400" data-id="element-1566" data-mp="2fqndu1cxgoxk" />
        <input type="text" value={locationSearch} onChange={e => setLocationSearch(e.target.value)} placeholder={placeholder} className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent" data-id="element-1567" data-mp="2kjq6865yxsc6" />
      </div>
    </div>;
};
export default SearchBar;